var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiDesigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noti-designer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noti-designer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLAYBOOK-Copy",
    transform: "translate(0.500000, 0.500000)",
    fill: "#BDCCD4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9836957,0.0448369565 C20.7196558,0.0448369565 20.4506341,0.0448369565 20.1766304,0.0448369565 C16.3057065,0.0199275362 13.0276268,1.29030797 11.4583333,3.18342391 C9.64492754,1.01630435 5.56476449,-0.378623188 0.891757246,0.119565217 L0.891757246,0.119565217 C0.384591539,0.173113549 -0.000269151334,0.600975433 -6.53853427e-06,1.11096014 L-6.53853427e-06,17.5063406 C-0.00101206985,17.7859464 0.115506959,18.0531109 0.321108837,18.2426057 C0.526710715,18.4321006 0.802473295,18.5264859 1.08106884,18.5027174 L1.08106884,18.5027174 C1.43976449,18.4528986 1.82835145,18.4528986 2.24184783,18.4528986 C6.22735507,18.4528986 9.0321558,19.9474638 9.75951087,21.3922101 L9.75951087,21.3922101 C9.92915506,21.7288722 10.2742801,21.9409602 10.6512681,21.9402193 L11.2690217,21.9402193 C11.6460097,21.9409602 11.9911348,21.7288722 12.160779,21.3922101 L12.160779,21.3922101 C12.8881341,19.9474638 15.7078804,18.4528986 19.678442,18.4528986 C20.0919384,18.4528986 20.4805254,18.4528986 20.839221,18.4977355 L20.839221,18.4977355 C21.1178166,18.521504 21.3935791,18.4271187 21.599181,18.2376239 C21.8047829,18.048129 21.9213019,17.7809645 21.9202964,17.5013587 L21.9202964,1.01630435 C21.9212406,0.488546217 21.5105039,0.0515922191 20.9836957,0.0199275362 L20.9836957,0.0448369565 Z M7.97101449,15.727808 L7.97101449,6.23233696 L15.8872283,10.9800725 L7.97101449,15.727808 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiDesigner);
export default __webpack_public_path__ + "static/media/noti-designer.95fafd8ff709a099c97d50b9500e75ae.svg";
export { ForwardRef as ReactComponent };